(() => {
  const mobileQuery = window.matchMedia('(max-width: 48rem)');

  const updateSearchPlaceholders = () => {
    document.querySelectorAll('input[type="search"]').forEach((input) => {
      if (!input.dataset.desktopPlaceholder) input.dataset.desktopPlaceholder = input.placeholder;
      input.placeholder = mobileQuery.matches ? 'Search products or SKU' : input.dataset.desktopPlaceholder;
    });
  };

  const updateContactOptions = () => {
    const option = document.querySelector('.il-contact-form select option:first-child');
    if (!option) return;
    if (!option.dataset.desktopLabel) option.dataset.desktopLabel = option.textContent.trim();
    option.textContent = mobileQuery.matches ? 'Find the right product' : option.dataset.desktopLabel;
  };

  const initialiseFilters = () => {
    const panel = document.querySelector('.il-filter-panel');
    const toolbar = document.querySelector('.il-collection-toolbar');
    if (!panel || !toolbar || toolbar.querySelector('[data-mobile-filter-open]')) return;

    const count = document.querySelectorAll('.il-active-filters > a:not(.il-active-filters__clear)').length;
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'il-button il-button--secondary il-mobile-filter-trigger';
    trigger.dataset.mobileFilterOpen = '';
    trigger.setAttribute('aria-expanded', 'false');
    trigger.textContent = count ? `Filters (${count})` : 'Filters';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'il-mobile-filter-close';
    close.dataset.mobileFilterClose = '';
    close.setAttribute('aria-label', 'Close filters');
    close.textContent = '×';

    const heading = panel.querySelector('.il-filter-panel__heading');
    heading?.append(close);
    toolbar.insertBefore(trigger, toolbar.querySelector('.il-collection-sort'));

    const backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'il-filter-backdrop';
    backdrop.hidden = true;
    backdrop.setAttribute('aria-label', 'Close filters');
    document.body.append(backdrop);

    let lastFocused = null;
    const closePanel = () => {
      panel.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      backdrop.hidden = true;
      document.body.classList.remove('il-filter-lock');
      lastFocused?.focus();
    };
    const openPanel = () => {
      lastFocused = document.activeElement;
      panel.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      backdrop.hidden = false;
      document.body.classList.add('il-filter-lock');
      close.focus();
    };

    trigger.addEventListener('click', openPanel);
    close.addEventListener('click', closePanel);
    backdrop.addEventListener('click', closePanel);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) closePanel();
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = [...panel.querySelectorAll('button, input, select, summary, a[href]')].filter((element) => !element.disabled);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const labelQuickAddButtons = () => {
    document.querySelectorAll('.il-product-card__add').forEach((button) => {
      if (button.querySelector('.il-product-card__add-label')) return;
      const label = document.createElement('span');
      label.className = 'il-product-card__add-label';
      label.textContent = button.disabled ? 'Unavailable' : 'Add to basket';
      button.append(label);
    });
  };

  updateSearchPlaceholders();
  updateContactOptions();
  labelQuickAddButtons();
  initialiseFilters();
  mobileQuery.addEventListener('change', () => {
    updateSearchPlaceholders();
    updateContactOptions();
  });
})();
